import { Subject } from 'rxjs';
import {AUTH_TOKEN, REFRESH_TOKEN, USER_INFO} from "../config";

const subject = new Subject();

export const AuthService = {
    setLogin: (user: any) => {
        localStorage.setItem(AUTH_TOKEN, user?.access_token);
        localStorage.setItem(REFRESH_TOKEN, user?.refresh_token);
        localStorage.setItem(USER_INFO, JSON.stringify(user?.user));
        return subject.next({user});
    },
    setLogout: () => subject.next({}),
    getIsLogged: () => subject.asObservable()
};
